import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux'
import { useCookies } from 'react-cookie'
import { useState } from 'react';
import { getStyle } from "../../libs/todoSlice";
import React from "react";
import Swal from "sweetalert2";
import { getAddEmailColorRedux, getAddEmailRedux, getEmailRedux, getOneMailRedux, getStepRedux, setAddEmailColorRedux, setAddEmailRedux, setEmailRedux, setOneMailRedux, setStepRedux } from "../../libs/profileSlice";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';


const ConfirmEmail = () => {
    const [cookie] = useCookies(['account'])
    const [account, setAccount] = useState({})
    const style = useSelector(getStyle)
    const step = useSelector(getStepRedux)
    const dispatch = useDispatch()
    const email = useSelector(getEmailRedux)
    const addemail = useSelector(getAddEmailRedux)
    const addemailcolor = useSelector(getAddEmailColorRedux)
    const onemail = useSelector(getOneMailRedux)



    const setEmail = (action) => {
        dispatch(setEmailRedux({
            email: action,
        }))
    }

    const setOneMail = (action) => {
        dispatch(setOneMailRedux({
            onemail: action,
        }))
    }

    const setAddEmail = (action) => {
        dispatch(setAddEmailRedux({
            addemail: action,
        }))
    }

    const setAddEmailColor = (action) => {
        dispatch(setAddEmailColorRedux({
            addemailcolor: action,
        }))
    }

    const setStep = (action) => {
        dispatch(setStepRedux({
            step: action,
        }))
    }

    const sendEmail = async () => {
        await axios({
            method: 'POST',
            url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/profile/confirm/email`,
        })
            .then(({ data, status }) => {
                Swal.fire({
                    icon: 'success',
                    title: 'ส่งลิงค์ Active E-mail สำเร็จ',
                })
                setStep("profile")
            }, ({ response, status }) => {
                Swal.fire({
                    icon: 'error',
                    title: 'ส่งลิงค์ Active E-mail ไม่สำเร็จ',
                })
            })

    }

    return localStorage.getItem('account') && (
        <>
            <div style={{
                width: 'auto',
                height: '1024px',
                backgroundImage: 'url("/img/7389 1.jpg")',
                fontFamily: 'Sarabun',
                fontWeight: '500'
            }}>
                <div style={{ display: 'flex', justifyContent: 'center', }}>
                    <div style={{
                        backgroundColor: 'white',
                        padding: '60px',
                        borderRadius: '48px',
                        width: '60%',
                        maxWidth: '644px',
                        height: '80%',
                        maxHeight: '486px',
                        top: '25%',
                        bottom: '0',
                        position: 'fixed'

                    }}><ArrowBackIosNewIcon style={{ position: 'absolute', cursor: 'pointer' }} onClick={() => { setStep('profile') }} />
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            fontSize: '20px'
                        }}>
                            ตรวจสอบอีเมล<div style={{ color: '#3776E9' }}>&nbsp;{onemail.email}&nbsp;</div>ของคุณ
                        </div>
                        <div style={{
                            display: 'flex', justifyContent: 'center', marginBottom: '16px', fontSize: '20px'
                        }}>  เพื่อคลิกยืนยันตัวตน </div>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <img src="/img/check-email.jpg" style={{ width: '90%', maxWidth: '298px', height: '80%', maxHeight: '218px' }} />
                        </div>
                        <div style={{
                            display: 'flex', justifyContent: 'center', flexDirection: 'column', textDecorationLine: 'underline',
                            lineHeight: '21px', fontSize: '16px'
                        }}>
                            <button
                                onClick={() => {
                                    setStep("editprofile")
                                    setAddEmail(true)
                                    setAddEmailColor(true)
                                }}
                                style={{
                                    backgroundColor: 'white',
                                    color: '#3776E9',
                                    border: 'none',
                                    marginTop: '34px'
                                }}>แก้ไข One mail</button>
                            <button
                                onClick={() => { sendEmail() }}
                                style={{
                                    backgroundColor: 'white',
                                    color: '#3776E9',
                                    border: 'none'
                                }}>ส่งยืนยันอีเมลอีกครั้ง</button>
                        </div>
                    </div>
                </div >
            </div >
        </>
    )
}

export default ConfirmEmail